import type { ValueOf } from '../types';

export class RelayError extends Error {
  static Reason = {
    GET_TOPIC_SUBS_MISSING_PORT:
      "Can't obtain topic subscriptions. Missing port.",
    NO_LINK_SET: 'No link found when relaying message',
    HANDSHAKE_NOT_COMPLETED: 'Handshake not completed',
    OPERATION_TIMEOUT: 'Operation timed out',
    ORIGIN_NOT_ALLOWED: 'Origin not allowed',
    ORIGIN_NOT_RETRIEVED: 'Failed to probe for origin',
    PROXY_NOT_INITIALIZED: 'Proxy not initialized',
  } as const;

  constructor(public readonly reason: ValueOf<typeof RelayError.Reason>) {
    const errorMsg = `Failed to relay operation to window broker. (Reason: ${reason})`;
    super(errorMsg);
  }
}
